// Shared navbar behaviour across all 5 versions:
// - mobile hamburger menu open/close
// - scroll-aware background swap (navbar becomes solid after scrolling past the hero)
// - "Style" dropdown (links between the 5 version pages + design tool — real navigation now,
//   not a React context switch)
(function () {
  function initNavbar(nav) {
    var toggle = nav.querySelector('[data-nav-toggle]');
    var menu = nav.querySelector('[data-mobile-menu]');
    var styleToggle = nav.querySelector('[data-style-toggle]');
    var styleMenu = nav.querySelector('[data-style-menu]');

    if (toggle && menu) {
      toggle.addEventListener('click', function () {
        var isOpen = menu.classList.toggle('is-open');
        document.body.classList.toggle('mobile-menu-open', isOpen);
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    if (styleToggle && styleMenu) {
      styleToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        styleMenu.classList.toggle('is-open');
      });
      document.addEventListener('click', function (e) {
        if (!styleMenu.contains(e.target) && e.target !== styleToggle) {
          styleMenu.classList.remove('is-open');
        }
      });
    }

    var scrollThreshold = 40;
    function onScroll() {
      nav.classList.toggle('is-scrolled', window.scrollY > scrollThreshold);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init() {
    document.querySelectorAll('[data-navbar]').forEach(initNavbar);

    // Shared accordion helper (used by the Schools FAQ section)
    document.querySelectorAll('[data-accordion-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-accordion-item]');
        var wasOpen = item.classList.contains('is-open');
        item.parentElement.querySelectorAll('[data-accordion-item]').forEach(function (el) {
          el.classList.remove('is-open');
        });
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
